import {
  withUser,
  UserProps,
} from "@customer-tools-web/component-authentication";
import * as React from "react";
import { LoadableComponent } from "react-loadable";
import { withRouter, RouteComponentProps } from "react-router";

import { URL_PREFIX } from "../common/const";
import featureToggles from "../../config/feature-toggles.malaysia";

type Props = UserProps & RouteComponentProps;

export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
      if (!featureToggles.DYNAMIC_PRICING) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
      if (!props.user.permissions.dynamicPricing.canViewDynamicPricing) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [props.user?.permissions]);

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
